import { Swiper } from 'swiper/bundle';

var coverSlider = document.getElementById('sliderCover');

if (coverSlider) {
  initializeSwiper(coverSlider);
}

function initializeSwiper(swiperInstance) {
  var coverSliderNav = swiperInstance.querySelector('.slider-nav');
  var coverSlider = new Swiper(swiperInstance, {
    effect: 'fade',
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    slidesPerView: 1,
    slideActiveClass: 'slider-item-active',
  });

  coverSlider.on('slideChange', function () {
    Array.from(coverSlider.slides).forEach(function (slide) {
      if (slide.classList.contains('has-video')) {
        var video = slide.getElementsByTagName('video');
        video[0].classList.add('pause');
        video[0].pause();
      }
    });
    var navElements = coverSliderNav.querySelectorAll('.slider-nav-item');
    navElements.forEach(function (navElement) {
      navElement.classList.remove('active');
      if (navElement.dataset.slideIndex == coverSlider.activeIndex) {
        navElement.classList.add('active');
      }
    });
  });

  coverSlider.on('slideChangeTransitionStart', function () {
    if (coverSlider.slides[coverSlider.realIndex].classList.contains('has-video')) {
      var video = coverSlider.slides[coverSlider.realIndex].getElementsByTagName('video');
      video[0].play();
    }
  });

  coverSliderNav.querySelectorAll('li > a').forEach(function (el, key) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      swiperInstance.setAttribute('data-slider-autoplay', 'false');
      el.parentNode.classList.add('active');
      coverSlider.slideTo(el.parentNode.dataset.slideIndex);

      coverSliderNav.querySelectorAll('li').forEach(function (ell, els) {
        if (key !== els) {
          ell.classList.remove('active');
        }
      });
    });
  });
}

export { initializeSwiper };
